import actions from './actions';

const { FETCH_RATES_BEGIN, FETCH_RATES_SUCCESS, FETCH_RATES_ERR, FETCH_RATES_SUCCESS_MULTI_BOX,FETCH_RATES_BEGIN_MULTI_BOX } = actions;

const initialStateFilter = {
  data: null,
  rates: null,
  loading: false,
  error: null,
  detail: null,
};

const shipmentRateReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_RATES_BEGIN:
      return {
        rates: null,
        loading: true,
        error: null,
        detail: null,
      };
    case FETCH_RATES_BEGIN_MULTI_BOX:
      return {
        rates_multi_box: null,
        loading: true,
        error: null,
        detail: null,
      };
    case FETCH_RATES_SUCCESS:
      return {
        rates: data,
        loading: false,
        error: null,
        detail: null,
      };
    case FETCH_RATES_SUCCESS_MULTI_BOX:
      return {
        rates_multi_box: data,
        loading: false,
        error: null,
        detail: null,
      };
    case FETCH_RATES_ERR:
      return {
        rates: null,
        loading: false,
        error: err,
        detail: null,
      };

    default:
      return state;
  }
};

export default shipmentRateReducer;
